import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'

import Payment from 'components/Quote/Payment'
import Icon from 'discada/dist/Icon'
import Tag from 'discada/dist/Tag'

import PricingCard from 'components/VRP/PricingCard'
import Card from 'components/widgets/Card'

import VehicleChip from 'components/Chip/VehicleChip'
import Meta from 'components/VRP/Meta'

import { INTENTS, INTENTS_LABELS } from 'reducers/quoteReducers'
import {
  getInventoryChipProps,
  isShowingVehicle,
  getYMMT,
  isVehiclePinned,
  getSelectedFeatures,
} from 'selectors/inventorySelectors'

import { moneyShort } from 'utils'
import { togglePin } from 'actions/inventoryActions'
import { goToVehiclePage } from 'actions/pageStateActions'
import { getBestProgramQuoteParams } from 'selectors/quoteSelectors'

import './InventoryChip.scss'
export function QuoteBadges({ quotes }) {
  let quoteGroups = Object.keys(quotes).reduce((ret, k) => {
    let q = quotes[k]
    return { ...ret, [q.intent]: (ret[q.intent] || 0) + 1 }
  }, {})

  return (
    <div className="quote-badges">
      {Object.keys(INTENTS)
        .map(k => {
          let qg = quoteGroups[k]

          if (!qg) return null

          return (
            <span className="quote-badge" key={k}>
              <span className={c('has-quotes', `has-quotes-${k}`)}>
                <strong>{qg}</strong>
              </span>
              {INTENTS_LABELS[k] || k}
            </span>
          )
        })
        .filter(x => x)}
    </div>
  )
}

export function InventoryCardPreso(props) {
  // pin control and tags should be moved into children prop

  let {
      vehicle,
      ymmt,
      image,
      goToVehiclePage,
      isPinned,
      showPin,
      showTags,
      selectedFeatures = [],
      priceToShow,
      priceLabel,
      leaseParams,
      loanParams,
    } = props,
    pin = e => {
      e.stopPropagation()
      props.togglePin(vehicle.id)

      return false
    },
    vehicleDetails = (
      <>
        <div className="inventory-info-wrapper">
          <div className="inventory-info">
            <span className="inventory-info-ymmt">{ymmt}</span>
            <span className="inventory-info-meta">
              <strong>{vehicle.type}</strong>
              <span>
                STOCK# <strong>{vehicle.stockNumber}</strong>
              </span>
              <span>
                VIN <strong>{vehicle.vin}</strong>
              </span>
              <span>
                {priceLabel} <strong>{moneyShort(priceToShow)}</strong>
              </span>
            </span>
          </div>
        </div>
        {showPin && (
          <Icon
            icon="thumbtack"
            className={c('fav-control', { 'is-favved': isPinned })}
            onClick={pin}
          />
        )}
        {showTags && (
          <div className="tags tags-list">
            {selectedFeatures.map(f => {
              let isOk = vehicle.features.includes(f),
                color = isOk ? 'success' : null,
                icon = isOk ? 'check' : 'times'

              return (
                <Tag color={color} className="is-light" key={f}>
                  <Icon icon={icon} /> {f.replaceAll('-', ' ')}
                </Tag>
              )
            })}
          </div>
        )}
      </>
    ),
    footer = (
      <>
        <PricingCard
          mini
          autoHide
          showParams
          showRange
          mode="lease"
          vehicleId={vehicle.id}
          onClick={e => {
            e.stopPropagation()
            goToVehiclePage(vehicle.id, 'lease', leaseParams)

            return false
          }}
        />
        <PricingCard
          mini
          autoHide
          showParams
          showRange
          mode="loan"
          vehicleId={vehicle.id}
          onClick={e => {
            e.stopPropagation()
            goToVehiclePage(vehicle.id, 'loan', loanParams)

            return false
          }}
        />
      </>
    )

  return (
    <Card
      hero={image}
      footer={footer}
      content={vehicleDetails}
      className="inventory-card"
      onClick={() =>
        vehicle.id &&
        goToVehiclePage(vehicle.id, null, { ...loanParams, ...leaseParams })
      }
    />
  )
}

export function InventoryChip(props) {
  let {
      id,
      quoteId,
      vehicle,
      previousQuotes,
      isv,
      priceToShow,
      priceLabel,
      isPinned,
      hideBadges = false,
    } = props,
    pin = () => props.togglePin(vehicle.id)

  return (
    <VehicleChip
      className="inventory-chip"
      {...props}
      control={
        <span className={c({ 'pinner-is-pinned': isPinned })} onClick={pin}>
          <Icon size="small" icon="thumbtack" />
        </span>
      }
    >
      {!hideBadges && <QuoteBadges quotes={previousQuotes} />}

      <div className="pricing-wrapper">
        <div className="pricing">
          {!isv && (
            <div className="payments">
              <Payment
                range
                className="payment"
                vehicleId={id}
                quoteId={quoteId}
                mode="lease"
                label="Lease"
              />

              <Payment
                range
                className="payment"
                vehicleId={id}
                quoteId={quoteId}
                mode="loan"
                label="Loan"
              />
            </div>
          )}

          {!isv && (
            <div className="price">
              <strong>
                {priceToShow ? (
                  <span>
                    <small>{priceLabel}</small>
                    {moneyShort(priceToShow)}
                  </span>
                ) : (
                  <em>Call for Price</em>
                )}
              </strong>
              <Meta id={vehicle.id} />
            </div>
          )}
        </div>
      </div>
    </VehicleChip>
  )
}

function mapStateToProps() {
  let getProps = getInventoryChipProps()

  return (state, op) => {
    let props = getProps(state, op),
      { vehicle = {} } = props,
      priceToShow =
        vehicle.type === 'Used' && vehicle.sellingPrice
          ? vehicle.sellingPrice
          : vehicle.msrp,
      priceLabel = vehicle.type === 'Used' ? 'Price' : 'MSRP',
      leaseParams = getBestProgramQuoteParams(
        state,
        op.id,
        op.quoteId,
        'lease',
        'q',
      ),
      loanParams = getBestProgramQuoteParams(
        state,
        op.id,
        op.quoteId,
        'loan',
        'q',
      )

    return {
      ...props,
      loanParams,
      leaseParams,
      priceToShow,
      priceLabel,
      showPin: op.showPin,
      showTags: op.showTags,
      ymmt: getYMMT(state, op.id),
      image: get(vehicle, 'images[0].url', null),
      isv: isShowingVehicle(state),
      isPinned: isVehiclePinned(state, op.id),
      selectedFeatures: op.showTags ? getSelectedFeatures(state) : [],
    }
  }
}

export default connect(
  mapStateToProps,
  { togglePin },
)(InventoryChip)

export const InventoryCard = connect(
  mapStateToProps,
  { togglePin, goToVehiclePage },
)(InventoryCardPreso)
